// extracted by mini-css-extract-plugin
module.exports = {"Why":"Why_Why__lNoaJ"};